export default {
  title: 'Studio (V2)',
  description: 'Crie e gira o site do restaurante com o novo Website Studio.',
  retry: 'Tentar novamente',
  deleted: 'Projeto eliminado.',
  errors: {
    load: 'Não foi possível carregar o projeto do Studio (V2).',
    create: 'Não foi possível criar o projeto. Tente novamente.',
    delete: 'Não foi possível eliminar o projeto. Tente novamente.',
  },
  EmptyState: {
    title: 'Ainda não há projeto do Studio (V2)',
    description: 'Crie um projeto para construir o site no novo Website Studio. O Studio (V1) mantém-se como está.',
    description_no_access: 'Um gestor de onboarding pode criar o projeto para esta marca.',
    create: 'Criar projeto',
  },
  ProjectCard: {
    unnamed: 'Projeto sem nome',
    edit: 'Editar no Studio',
    delete: 'Eliminar',
    open: 'Abrir',
    no_domain: 'Ainda sem domínio',
    fields: {
      uuid: 'UUID',
      domain: 'Domínio',
      websites: 'Websites',
    },
    delete_confirm: {
      title: 'Eliminar este projeto?',
      description: 'Isto remove o projeto do Studio (V2) e os respetivos websites. Pode criar um novo mais tarde.',
      ok: 'Eliminar',
      cancel: 'Cancelar',
    },
  },
};
